import URI from "urijs";
import VantToast from "vant/lib/toast";
import Dialog from "vant/lib/dialog";
import { getStore } from "@/store";
import { openLogin } from "@/utils/login";

const okButtonText = "确认";
const cancelButtonText = "取消";

export function isApp() {
  const { isApp: flag } = URI(location.href).query(true) || {};
  return !!(window.tyApp && flag);
}
export function getAppInstance() {
  if (isApp()) {
    return window.tyApp;
  }
}

export async function checkLogin() {
  const store = getStore();
  let userInfo = store?.getters?.userInfo;
  if (userInfo) return true;
  // 如果vuex中没有用户信息，先调用接口获取，并缓存到vuex中
  userInfo = await store.dispatch("user/getUserInfo");
  if (!userInfo) {
    Toast.fail("请先登录");
    openLogin();
    return false;
  }
  return true;
}

export class Toast {
  constructor(message) {
    Toast.success(message?.message || message);
  }
  static genDialogOptions({ message, title = "提示" }) {
    return {
      dialogOptions: {
        message,
        title,
        okButtonText,
        cancelable: true,
        cancelButtonText,
      },
    };
  }
  static success(message, title) {
    const tyApp = getAppInstance();
    if (tyApp) {
      return tyApp?.alert?.(Toast.genDialogOptions({ message, title }));
    } else {
      return VantToast.success(message);
    }
  }
  static fail(message, title) {
    const tyApp = getAppInstance();
    if (tyApp) {
      return tyApp?.alert?.(Toast.genDialogOptions({ message, title }));
    } else {
      return VantToast.fail(message);
    }
  }
  static info(message, title) {
    const tyApp = getAppInstance();
    if (tyApp) {
      return tyApp?.alert?.(Toast.genDialogOptions({ message, title }));
    } else {
      return VantToast(message);
    }
  }
  static alert({ title, message }) {
    return Toast.success(message, title);
  }
  static async confirm({ title, message, ...arg }) {
    const tyApp = getAppInstance();
    if (tyApp) {
      const result = await tyApp?.confirm?.(
        Toast.genDialogOptions({ message })
      );
      if (result === true) {
        return null;
      } else {
        throw "cancel";
      }
    } else {
      return Dialog.confirm({ title, message, ...arg });
    }
  }
}
